import * as customerService from '../../../services/customerService'
class verifyAccountResult {
  constructor(isVerified) {
    this.isVerified = isVerified
  }

  sendLiveCheckVerificationEmail = async app =>
    await customerService.SendLiveCheckVerificationEmail(
      app.state.token,
      app.state.branchId,
      app.state.accountNumber,
      app.state.contractNumber,
      app.state.branch.email,
      this.isVerified
    )

  async next(currentStep, app) {
    this.verificationAttempts = app.state.verificationAttempts
    this.verificationAttempts++

    if (!this.isVerified && this.verificationAttempts < 3) {
      app.setState({
        verificationAttempts: this.verificationAttempts,
      })
    } else if (!this.isVerified && this.verificationAttempts >= 3) {
      app.setState({
        failedVerification: true,
      })
      this.sendLiveCheckVerificationEmail(app)
    } else if (this.isVerified) {
      this.sendLiveCheckVerificationEmail(app).then(result => {
        if (result) {
          app.setState({failedVerification: false})
        }
      })
    }
  }
}

export default verifyAccountResult
